// extracted by mini-css-extract-plugin
module.exports = {"exitEventImage":"ExitEvent_exitEventImage__335LZ","closeDiv":"ExitEvent_closeDiv__2kJs-"};